import * as React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';

import { Context } from '../../Context';
import { Disclaimers } from './Disclaimers';
import { ConsumptionAndEmissions } from './ConsumptionAndEmissions';

export interface LegalInfoProps {
  consumptionAndEmissions?: string[];
  disclaimers?: string[];
  topSpace: string;
}

const StyledLegalInfo = styled.div<{ topSpace: string }>`
  padding-top: ${(props) => props.topSpace};
`;

export const LegalInfo: React.FC<LegalInfoProps> = ({
  consumptionAndEmissions,
  disclaimers,
  topSpace,
}) => {
  const { localeService, vueFormatterService, loggerService } = useContext(Context);
  const hasCaE = Boolean(consumptionAndEmissions && consumptionAndEmissions.length > 0);
  const hasDisclaimers = Boolean(disclaimers && disclaimers.length > 0);

  if (!hasCaE && !hasDisclaimers) {
    return null;
  }

  return (
    <StyledLegalInfo topSpace={topSpace}>
      {hasCaE && vueFormatterService && localeService && (
        <ConsumptionAndEmissions
          caeIds={consumptionAndEmissions}
          vueFormatterService={vueFormatterService}
          localeService={localeService}
          loggerService={loggerService}
        />
      )}
      {hasDisclaimers && <Disclaimers disclaimers={disclaimers} />}
    </StyledLegalInfo>
  );
};

LegalInfo.displayName = 'LegalInfo';
